<template>
  <div
    class="hover:text-mi-yellow-500 p-4 mr-2 flex items-center flex-col"
    :class="{ active: 'cursor-pointer' }"
  >
    <i
      class="material-icons md-3xl  mb-2"
      :class="{ 'text-mi-purple-400': active, 'text-gray-300': !active }"
      >{{ icon_name }}</i
    >

    <div class="text-xs -mt-1" :class="{ 'text-gray-300': !active }">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["icon_name", "text", "active"]
};
</script>

<style></style>
